
let environment:any;

export function applyConfig(data:any) {
  environment = data;
}
export { environment };